<template>
<transition name="ui-toast">
  <div class="ui-toast" v-show="isVisible">
    <slot>
      <div class="ui-toast-text">{{text}}</div>
    </slot>
  </div>
</transition>
</template>

<script>
export default {
  data () {
    return {
      isVisible: false
    }
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    show () {
      this.isVisible = true
      this.clearTimer()
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          this.hide()
        }, 2000)
      })
    },
    hide () {
      this.isVisible = false
      this.clearTimer()
    },
    clearTimer () {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="less">
.ui-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 80%;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  text-align: center;
  padding: 10px 20px;
  z-index: 999999;
  transform: translate3d(-50%, -50%, 0);
  .ui-toast-text{
    font-size: 19px;
    display: block;
    text-align: center;
  }
}

.ui-toast-enter-active, .ui-toast-leave-active {
  transition: opacity .3s linear;
}
.ui-toast-enter, .ui-toast-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/christmasPC-2019/components/toast/index.vue